import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';


interface StyledBoxProps {
  disabled?: boolean;
}


const StyledBox = styled(Box)<StyledBoxProps>(({ theme, disabled }) => ({
   height: '100%',
   display: 'flex',
   flexDirection: 'column',
   justifyContent: 'center',
   alignItems: 'flex-start',
   [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  '& .VCCountNum': {
    width: theme.spacing(5),
    height: theme.spacing(3.75),
    textAlign: 'center',
    borderRadius: theme.spacing(0.5),
    background: theme.palette.divider[4],
    color: disabled? theme.palette.action.disabled : theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '& .VCLabel': { 
    color: disabled? theme.palette.action.disabled : theme.palette.common.white,
  },
  '& .VCBtn': {
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    minWidth: 'unset',
    borderRadius: '50% !important',
    padding: theme.spacing(1),
    color: theme.palette.common.white,
    borderColor: `${theme.palette.border[2]} !important`,
    background: theme.palette.secondary.main,
    backdropFilter: `blur(${theme.spacing(1)})`,
    '&:active, &:hover': {
      color: theme.palette.common.white,
    borderColor: `${theme.palette.border[2]} !important`,
    },
    '&.Mui-disabled': {
      color: theme.palette.action.disabled,
    },
  },
  '& .VCDiscountChip':{
    opacity: 0.9,
    color: theme.palette.common.black,
    borderRadius:theme.spacing(0.5),
    padding : theme.spacing(0.5, 0.75),
    height: 'fit-content',
    '& .MuiChip-label':{
      paddingLeft: 0,
      paddingRight: 0,
      lineHeight: theme.spacing(1.75),
      fontWeight: 500,
      fontSize: theme.spacing(1.75),
    },
  },
}));

export default StyledBox;